/* ============================================================
   IMENHOF BLOOM — theme.js (globale kern)
   Alleen wat op elke pagina nodig is: drawers, scroll-lock,
   sticky header, meldingen, winkelwagen (drawer + add + kaart-
   quickadd). Productgalerij/variantkiezer staan in product.js
   (alleen productpagina). Filteren/oneindig laden in refine.js
   (collectie + zoeken).
   ============================================================ */
(function () {
  'use strict';
  document.documentElement.classList.add('js');
  const money = (cents) => window.Shopify && Shopify.formatMoney
    ? Shopify.formatMoney(cents, window.themeMoneyFormat)
    : '€' + (cents / 100).toFixed(2).replace('.', ',');

  /* ---------- Toast ---------- */
  let toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span>✓</span>' + msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(() => toastEl.classList.remove('is-show'), 2600);
  }

  /* ---------- Scroll lock (iOS-proof) ----------
     body{overflow:hidden} wordt door iOS Safari genegeerd;
     position:fixed met scrollpositie-herstel werkt overal. */
  let lockY = 0;
  let isLocked = false;
  function lockScroll() {
    if (isLocked) return;
    lockY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = (-lockY) + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    isLocked = true;
  }
  function unlockScroll() {
    if (!isLocked) return;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    isLocked = false;
    const prev = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(0, lockY);
    document.documentElement.style.scrollBehavior = prev;
  }

  /* ---------- Drawer controller ---------- */
  function openDrawer(el) {
    if (!el) return;
    el.classList.add('is-open');
    lockScroll();
    const focusable = el.querySelector('input,button,a');
    setTimeout(() => focusable && focusable.focus(), 300);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    if (!document.querySelector('.drawer.is-open')) unlockScroll();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')));
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__overlay')) {
      const d = e.target.closest('.drawer');
      if (d) closeDrawer(d);
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
  });

  /* ---------- Sticky header on scroll ---------- */
  const header = document.querySelector('.header-wrap');
  if (header) {
    let last = 0;
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 8);
      last = y;
    }, { passive: true });
  }

  /* ---------- Announcement rotation ---------- */
  document.querySelectorAll('[data-announce]').forEach((box) => {
    const items = box.querySelectorAll('.announce__item');
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  });

  /* ---------- Reveal on scroll ----------
     rootMargin van 200px onder de viewport: elementen beginnen hun fade-in
     vóórdat ze in beeld komen, zodat je bij het scrollen nooit tegen een
     leeg vlak aankijkt. threshold laag houden — anders wacht de animatie
     tot een fors deel van de sectie zichtbaar is. */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.01, rootMargin: '0px 0px 200px 0px' });
    document.querySelectorAll('.reveal').forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll('.reveal').forEach((el) => el.classList.add('is-in'));
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.qty button');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    let val = parseInt(input.value, 10) || 0;
    val += btn.dataset.dir === 'up' ? 1 : -1;
    if (val < parseInt(input.min || 0, 10)) val = parseInt(input.min || 0, 10);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ============================================================
     CART
     ============================================================ */
  const cartDrawer = document.getElementById('CartDrawer');

  async function fetchCart() {
    const r = await fetch('/cart.js');
    return r.json();
  }
  function renderCart(cart) {
    const body = document.getElementById('CartDrawerBody');
    const foot = document.getElementById('CartDrawerFoot');
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><div class="cart-empty__icon">🪴</div><h3>Je winkelwagen is leeg</h3><p>Ontdek onze planten en voeg je favorieten toe.</p><a class="btn" href="/collections/all" data-drawer-close>Bekijk planten</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    const threshold = parseInt(body.dataset.freeShip || 0, 10);
    const localThreshold = parseInt(body.dataset.localThreshold || 0, 10);
    const localRadius = parseInt(body.dataset.localRadius || 10, 10);
    let progress = '';
    if (threshold > 0) {
      const localPending = localThreshold > 0 && cart.total_price < localThreshold;
      const target = localPending ? localThreshold : threshold;
      const pct = Math.min(100, (cart.total_price / target) * 100);
      const remain = threshold - cart.total_price;
      const localRemain = localThreshold - cart.total_price;
      let progressMessage = '';
      if (localPending) {
        progressMessage = 'Nog ' + money(localRemain) + ' tot lokale bezorging binnen ' + localRadius + ' km 🌿';
      } else if (remain > 0) {
        progressMessage = 'Lokale bezorging binnen ' + localRadius + ' km is beschikbaar. Nog ' + money(remain) + ' tot bezorging buiten ' + localRadius + ' km 🌿';
      } else {
        progressMessage = 'Je komt in aanmerking voor bezorging aan huis 🌿';
      }
      progress = '<div class="cart-progress"><div class="cart-progress__bar"><div class="cart-progress__fill" style="width:' + pct + '%"></div></div><p>' + progressMessage + '</p></div>';
    }
    body.innerHTML = progress + cart.items.map((it) => {
      const img = it.image ? '<img src="' + it.image.replace(/(\.[^.]+)$/, '_160x$1') + '" alt="" width="74" height="74">' : '<div style="width:74px;height:74px;border-radius:10px;background:var(--surface-2)"></div>';
      const variant = (it.product_has_only_default_variant) ? '' : '<p class="cart-line__variant">' + it.variant_title + '</p>';
      return '<div class="cart-line" data-key="' + it.key + '">' + img +
        '<div><a href="' + it.url + '" class="cart-line__title">' + it.product_title + '</a>' + variant +
        '<div class="qty qty--sm"><button type="button" data-cart-minus aria-label="Minder">−</button><input type="text" value="' + it.quantity + '" data-cart-qty readonly><button type="button" data-cart-plus aria-label="Meer">+</button></div>' +
        '<button class="cart-line__remove" data-cart-remove>Verwijderen</button></div>' +
        '<div class="cart-line__price">' + money(it.final_line_price) + '</div></div>';
    }).join('');
    if (foot) {
      foot.querySelector('[data-cart-total]').textContent = money(cart.total_price);
    }
  }

  async function changeLine(key, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    return r.json();
  }

  if (cartDrawer) {
    cartDrawer.addEventListener('click', async (e) => {
      const line = e.target.closest('.cart-line');
      if (!line) return;
      const key = line.dataset.key;
      const qtyEl = line.querySelector('[data-cart-qty]');
      let qty = parseInt(qtyEl.value, 10);
      if (e.target.closest('[data-cart-plus]')) qty += 1;
      else if (e.target.closest('[data-cart-minus]')) qty -= 1;
      else if (e.target.closest('[data-cart-remove]')) qty = 0;
      else return;
      line.style.opacity = '.5';
      const cart = await changeLine(key, Math.max(0, qty));
      renderCart(cart);
    });
  }

  /* ---------- Add to cart (forms + quick add) ---------- */
  async function addToCart(formData) {
    const r = await fetch('/cart/add.js', { method: 'POST', body: formData });
    if (!r.ok) { const err = await r.json(); throw new Error(err.description || 'Er ging iets mis'); }
    return r.json();
  }
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form], [data-quick-add]');
    if (!form) return;
    e.preventDefault();
    const submit = form.querySelector('[type=submit]');
    const original = submit ? submit.innerHTML : '';
    if (submit) { submit.disabled = true; submit.innerHTML = 'Bezig…'; }
    try {
      await addToCart(new FormData(form));
      const cart = await fetchCart();
      renderCart(cart);
      openDrawer(cartDrawer);
      toast('Toegevoegd aan winkelwagen');
    } catch (err) {
      toast(err.message);
    } finally {
      if (submit) { submit.disabled = false; submit.innerHTML = original; }
    }
  });

  /* ---------- Kaart: quick-add onder de prijs + inline aantal-stepper ----------
     Eigen class 'pcard__stepper' (niet '.qty'), zodat de generieke
     qty-handler hierboven er niet op vuurt. Hergebruikt addToCart/fetchCart/
     renderCart/toast, zodat de winkelwagen-drawer netjes meeloopt. */
  function cardStepperHTML(id, qty) {
    return '<div class="pcard__stepper" data-card-qty data-variant-id="' + id + '">' +
      '<button type="button" data-card-minus aria-label="Eén minder">−</button>' +
      '<input type="text" value="' + qty + '" data-card-qtyval readonly aria-label="Aantal in winkelwagen">' +
      '<button type="button" data-card-plus aria-label="Eén meer">+</button></div>';
  }
  function cardAddBtnHTML(id) {
    return '<button type="button" class="btn btn--secondary btn--full btn--sm pcard__addbtn" data-card-add data-variant-id="' + id + '">In winkelmand</button>';
  }
  async function cartChangeById(id, quantity) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: String(id), quantity: quantity })
    });
    return r.json();
  }
  function cardLineQty(cart, id) {
    const line = cart.items.find((it) => String(it.variant_id) === String(id));
    return line ? line.quantity : 0;
  }
  document.addEventListener('click', async (e) => {
    const add = e.target.closest('[data-card-add]');
    if (add) {
      e.preventDefault();
      if (add.disabled) return;
      const wrap = add.closest('[data-card-add-wrap]');
      const id = add.dataset.variantId;
      const orig = add.innerHTML;
      add.disabled = true;
      add.innerHTML = 'Bezig…';
      try {
        const fd = new FormData();
        fd.append('id', id);
        fd.append('quantity', 1);
        await addToCart(fd);
        const cart = await fetchCart();
        renderCart(cart);
        if (wrap) wrap.innerHTML = cardStepperHTML(id, cardLineQty(cart, id) || 1);
        toast('Toegevoegd aan winkelwagen');
      } catch (err) {
        add.disabled = false;
        add.innerHTML = orig;
        toast(err.message || 'Er ging iets mis');
      }
      return;
    }
    const step = e.target.closest('[data-card-qty] [data-card-plus], [data-card-qty] [data-card-minus]');
    if (step) {
      const box = step.closest('[data-card-qty]');
      if (box.dataset.busy) return;
      const wrap = box.closest('[data-card-add-wrap]');
      const id = box.dataset.variantId;
      const input = box.querySelector('[data-card-qtyval]');
      let next = (parseInt(input.value, 10) || 0) + (step.hasAttribute('data-card-plus') ? 1 : -1);
      if (next < 0) next = 0;
      box.dataset.busy = '1';
      box.style.opacity = '.6';
      try {
        const cart = await cartChangeById(id, next);
        renderCart(cart);
        const q = cardLineQty(cart, id);
        if (q <= 0) {
          if (wrap) wrap.innerHTML = cardAddBtnHTML(id);
        } else {
          input.value = q;
          box.style.opacity = '';
          delete box.dataset.busy;
        }
      } catch (err) {
        box.style.opacity = '';
        delete box.dataset.busy;
        toast('Kon winkelwagen niet bijwerken');
      }
      return;
    }
  });

  /* ---------- Initial cart sync ---------- */
  fetchCart().then(renderCart).catch(() => {});
})();
